type ModuleName =
	| 'admin'
	| 'workflow'
	| 'media'
	| 'collections'
	| 'brands'
	| 'news'
	| 'account'
	| 'login'
	| 'guidelines'
	| 'templating'
	| 'styleguide'
	| 'group'
	| 'cockpit'
	| 'taxonomy'
	| 'pod'
	| 'share';

type ViewName =
	| 'job/overview'
	| 'job/view'
	| 'main/index'
	| 'campaign/overview'
	| 'campaign/dashboard'
	| 'campaign/calendar'
	| 'view'
	| 'dashboard';

export const isColdfusion = () => {
	return Boolean(window?.bynder?.Locale);
};

export const isModule = (moduleName: ModuleName) => {
	return (
		moduleName.toLowerCase() === (window.location.pathname.split('/')[1] || '').toLowerCase()
	);
};

export const getCollectionIdFromPath = () => {
	const { pathname } = window.location;
	const keyUrl = 'collections/view/';
	const keyUrlIndex = pathname.indexOf(keyUrl);

	if (keyUrlIndex === -1) {
		return '';
	}

	const idIndex = keyUrlIndex + keyUrl.length;

	return pathname.slice(idIndex).split('/')[0];
};

export const isView = (viewName: ViewName) => {
	return window.location.pathname
		.split('/')
		.slice(2)
		.join('/')
		.toLowerCase()
		.includes(viewName.toLowerCase());
};

export const isMainView = () => {
	return window.location.pathname.split('/').slice(2)[0] === '';
};

export const isCollectionDetailView = () => {
	return (
		window.location.pathname.startsWith('/collections/view/') || // Regular collection detail view
		window.location.pathname.startsWith('/web/') || // Public collection detail view
		window.location.pathname.startsWith('/share/') // Shared collection detail view
	);
};
